import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { getAccessToken, isSecondaryUser, getDefaultHomePath } from "utils/auth";

/**
 * Ruta protegida: exige access token.
 * principalOnly: redirige usuarios secundarios a /special
 */
function PrivateRoute({component: Component, principalOnly = false, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!getAccessToken()) {
          return (
            <Redirect
              to={{
                pathname: "/authentication/sign-in",
                state: { from: props.location },
              }}
            />
          );
        }

        if (principalOnly && isSecondaryUser()) {
          return <Redirect to="/special" />;
        }

        return <Component {...props} />;
      }}
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  principalOnly: PropTypes.bool,
};

/**
 * Solo visitantes (login). Si ya hay sesión, redirige al inicio correspondiente.
 */
function PublicRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (getAccessToken()) {
          return <Redirect to={getDefaultHomePath()} />;
        }
        return <Component {...props} />;
      }}
    />
  );
}

PublicRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export { PrivateRoute, PublicRoute };
